var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function SocialShare(el) {
    this.el = el;
    var $el = $( el ),
        $a = $el.find( ".js-modal" );

    $a.on( "click", function( e ) {
        e.preventDefault();
       
        var w = 500,
            h = 300,
            left = ($( window ).width() / 2) - (w / 2),
            top = ($( window ).height() / 2) - (h / 2);

        window.open( this.href, "socialWindow", "width=" + w + ",height=" + h + ",top=" + top + ",left= " + left );
        
    });
}

module.exports = SocialShare;
